/**
 * Capitalizes the first letter of each word.
 * @param string The input string
 * @param separators Array of separators, default: [' ', '-', '_']
 */
export const capitalizeWords = (
  string: string,
  separators: [' ', '-', '_'] | string[] = [' ', '-', '_']
) => {
  let str = string.toLowerCase();
  const separatorsSet = new Set(separators);
  for (const separator of separatorsSet) {
    str = str.split(separator).join(' ');
  }
  return str
    .trim()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
